import RouteData from '@/models/RouteData';
import SupportedContext from '@/types/SupportedContext';
import SearchDefaults from '@/types/SearchDefaults';
import ValidateSearchTerm from '@/rules/ValidateSearchTerm';
import FilterSerializedOptions from '@/models/FilterSerializedOptions';
import { Dictionary } from 'vue-router/types/router';

interface PotentiallyWrongRouteData {
  searchContext?: string | null | undefined;
  query: Dictionary<string | (string | null)[]>;
}

export default class ValidateRouteData {
  public static validate(data: PotentiallyWrongRouteData): RouteData {
    const { q, ...filters } = data.query;
    const searchTerm: string = this.ensureValidSearchTerm(q as string);
    const filterSerializedOptions: FilterSerializedOptions = this.ensureValidFilters(filters);
    return {
      searchContext: this.ensureValidContext(data.searchContext),
      searchTerm,
      filterSerializedOptions,
    };
  }

  private static ensureValidContext(
    searchContext: string | SupportedContext | null | undefined,
  ): SupportedContext {
    if (!Object.values<SupportedContext>(SupportedContext)
      .includes(searchContext as SupportedContext)) {
      return SearchDefaults.searchContext;
    }
    return searchContext as SupportedContext;
  }

  private static ensureValidSearchTerm(searchTerm: string): string {
    return ValidateSearchTerm.validate(searchTerm || '');
  }

  private static ensureValidFilters(
    filters: Dictionary<string | (string | null)[]>,
  ): FilterSerializedOptions {
    const checkedFilters: FilterSerializedOptions = {};
    Object.keys(filters).forEach((filterId: string) => {
      checkedFilters[filterId] = filters[filterId] as string;
    });
    return checkedFilters;
  }
}
